import React from "react";
import FontAwesome from 'react-fontawesome';
import {EntryDesc} from 'generated/JavaTOmodifications'
import {Button, Divider} from '@mui/material'
import {MenuListProps} from 'react-select'
import {EntryDescCustomProps} from 'module/edesc/component/EntryDescCustomProps'
import {css} from '@emotion/react'
import {ButtonWithIcon} from 'component/ButtonWithIcon'
import {Close, CloudUpload, Star} from '@mui/icons-material'

const buttonProps = {
	size: 'small',
	// variant: "outlined",
} as const

const cssRoot = css`
	max-height: 340px;
	min-width: 300px;
	background: white;
	overflow-y: auto;
`
const cssFavEditButton = css`
	width: 100%;
	text-align: right;
	border-bottom: #fafafa;
`
const cssFavButtons = css`
	padding: 0 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #cccccc;
`
const cssHint = css`
	font-size: small;
	padding: 4px 8px;
`

export function EntryDescSelectMenuList(props: MenuListProps<EntryDesc, false> & { selectProps: EntryDescCustomProps }) {
	const {entryDescFavEditMode, setEntryDescFavEditMode} = props.selectProps;
	if (entryDescFavEditMode) {
		return (
			<div>
				<div css={cssFavButtons}>
					<ButtonWithIcon
						{...buttonProps}
						onClick={() => setEntryDescFavEditMode({status: false})}
						icon={<CloudUpload/>}
						label={'Favoriten sichern'}
					/>
					<ButtonWithIcon
						{...buttonProps}
						onClick={() => setEntryDescFavEditMode({status: false, reset: true})}
						icon={<Close/>}
						label={'Abbrechen'}
					/>
				</div>
				<div css={cssRoot}>
					<div css={cssHint}><Star fontSize={'inherit'}/> Einträge anklicken um sie als Verknüpfung in leeren Feldern zu sehen.</div>
					<div css={cssHint}><Star fontSize={'inherit'}/> Gewählte Favoriten im Eingabefeld anklicken um sie an die erste Stelle zu setzen.</div>
					<div css={cssHint}><Star fontSize={'inherit'}/> Die Favoriten können auch vertikal gescrollt werden (z.B. Shift + Scrollrad)</div>
					{props.children}
				</div>
			</div>
		)
	} else {
		return (
			<div {...buttonProps} css={cssRoot}>
				<div>
					{entryDescFavEditMode !== undefined &&
						<div css={cssFavEditButton}>
							<Button {...buttonProps} fullWidth onClick={() => setEntryDescFavEditMode({status: true})}>
								<FontAwesome name={'star'}/>
								&nbsp; Favoriten bearbeiten
							</Button>
						</div>
					}
					{props.children}
				</div>
			</div>
		)
	}
}